import React, { Component } from "react";
import styled from "styled-components";
import { Swipeable } from "react-swipeable";
import { connect } from "react-redux";

import Map from "../../components/Map";
import HomeSearchIcon from "../../components/icons/HomeSearch";
import PublicGraph from "../../components/graphs/PublicServicesGraph";
import MobileOnlyCloseIcon from "../../components/icons/MobileClose";
import CircleGraph from "../../components/graphs/CircleFillGraph";
import Textfield from "../../components/TextField";
import Preloader from "../../components/Preloader";
import {
  Main,
  SwitchButtonsWrap,
  SwitchButton,
  PageDetail,
  LocationCirclesGraphContainer as CirclesGraphContainer,
  MapExplainText,
  LocationDetailContainer,
  LocationCircleGraphsTitle,
  SingleCircleLocationCard,
  SingleCircleDetail,
  CircleAndDetail
} from "../../components/StyledComponents";

import { getDevice, devices } from "../../services/getDevice";
import {
  handleLocationClick,
  handleLocationSwipe,
  closeZoom,
  changeMapView,
  settingsToggle,
  resetState,
  getLocations
} from "./data/actions";
import { filterService } from "../Services/data/actions";
import { toggleScroll, toggleLoading } from "../../containers/data/actions";

const Options = styled.div`
  height: 100vh;
  display: flex;
  background-color: ${props => props.theme.mapOptions};
  transition: background-color ease 1s;
  width: 18.5%;
  position: fixed;
  top: 0;
  right: 5%;
  text-align: right;
  justify-content: flex-end;
  padding-right: 5%;
  padding-right: 2%;
  padding-top: 3%;
  @media (min-width: 1800px) {
    padding-top: 34px;
    right: 4.6%;
    width: 17%;
  }
  @media (max-width: 575px) {
    position: absolute;
    visibility: ${props => (props.mobileShow ? "visible" : "hidden")};
    left: ${props => (props.mobileShow ? 0 : "-100%")};
    transition: left ease-in-out 0.4s, visibility ease-in-out 0.4s;
    height: 76vh;
    box-sizing: border-box;
    width: 100%;
    background-color: ${props => props.theme.backgroundSecondary};
    z-index: 2;
    border-bottom: 1px solid ${props => props.theme.border};
    border-top: 1px solid ${props => props.theme.border};
  }
`;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: fit-content;
  padding: 0 0 0 15%;
  @media (max-width: 575px) {
    padding: 0 25px 0 35%;
  }
`;

const Title = styled.div`
  font-family: "dubai-bold";
  font-size: 15px;
  color: ${props => props.theme.textHighlight};
  text-align: right;
  margin-bottom: 12%;
  @media (min-width: 1800px) {
    font-size: 21px;
    line-height: 36px;
    margin-bottom: 11px;
  }
  @media (max-width: 575px) {
    font-family: "dubai-medium";
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 16px;

    display: flex;
    justify-content: flex-end;
  }
`;

const LocationDetail = styled.div`
  width: 55vw;
  height: fit-content;
  border-radius: 49px 49px 0 0;
  background-color: ${props => props.theme.backgroundTertiary};
  transition: background-color ease 1s;
  margin: 0 0.25%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: margin-top ease 1s;
  @media (max-width: 575px) {
    width: 90vw;
  }
`;

const TopHandle = styled.div`
  width: 97px;
  height: 5px;
  background-color: #707070;
  margin-top: 15px;
  border-radius: 10px;
  @media (max-width: 575px) {
    margin-bottom: 22px;
  }
`;

class ServiceCenters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSwipedUp: false
    };
  }



  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isSettingOpen !== this.props.isSettingOpen) {
      if (this.props.scroll) this.props.toggleScroll(false);
      else this.props.toggleScroll(true);
    }


  }

  componentWillUnmount() {
    this.props.resetState();
  }

  render() {
    const { isSwipedUp } = this.state;

    const {
      cardNo,
      zoomed,
      handleLocationClick,
      serviceCenterLocations,
      handleLocationSwipe,
      activeLocation,
      filterService,
      data,
      filteredData,
      isFiltered,
      changeMapView,
      view,
      closeZoom,
      isSettingOpen,
      settingsClose,
      isLoading,
      theme,
      counts,
      totalCount
    } = this.props;

    const serviceKPIsData = isFiltered ? filteredData : data;

    return (
      <>

        <Main stopScroll>
          <Map
            view={view}
            dragPan={!(view === "VIZ" || zoomed)}
            activeLocation={activeLocation}
            onMapClick={place => handleLocationClick(place.datum)}
            onZoomClose={closeZoom}
            markLocations={serviceCenterLocations}
            zoomed={zoomed}
            changeMapView={changeMapView}
            counts={counts}
            totalCount={totalCount}
          >
            <Options mobileShow={isSettingOpen}>
              <ActionsContainer>
                <Title>
                  مراكز الخدمة <MobileOnlyCloseIcon onClick={settingsClose} />
                </Title>
                <MapExplainText>
                  هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما
                  سيلهي
                </MapExplainText>
                <SwitchButtonsWrap>
                  <SwitchButton
                    onClick={() => changeMapView("MAP")}
                    outlined={view === "VIZ"}
                  >
                    مواقع
                  </SwitchButton>
                  <SwitchButton
                    onClick={() => changeMapView("VIZ")}
                    outlined={view === "MAP"}
                  >
                    مؤشرات
                  </SwitchButton>
                </SwitchButtonsWrap>
                <Textfield
                  defaultValue=""
                  placeholder="بحث بإسم مركز الخدمة"
                  rounded
                  icon={<HomeSearchIcon />}
                />
              </ActionsContainer>
            </Options>
            {zoomed && view === "MAP" && (
              <Swipeable
                trackMouse
                onSwipedUp={() =>
                  this.setState({
                    isSwipedUp: true
                  })
                }
                onSwipedDown={() =>
                  this.setState({
                    isSwipedUp: false
                  })
                }
                onSwipedLeft={() => handleLocationSwipe("Left")}
                onSwipedRight={() => handleLocationSwipe("Right")}
              >
                <LocationDetailContainer
                  cardNo={cardNo}
                  isSwipedUp={isSwipedUp}
                >
                  {[...Array(serviceCenterLocations.length)].map((_, i) => (
                    <LocationDetail key={i}>
                      <TopHandle />
                      {getDevice() !== devices.mobile && (
                        <>
                          <PageDetail>
                            المؤشر المئوي لمجموع الخدمات للجهة الحكومية
                          </PageDetail>
                          <PublicGraph
                            onServiceFilter={filterService}
                            id="public-graph-1"
                          />
                        </>
                      )}
                      <LocationCircleGraphsTitle>
                        متوسط أداء مؤشرات الخدمات
                      </LocationCircleGraphsTitle>
                      <CirclesGraphContainer>
                        {serviceKPIsData.map((item, i) => (
                          <CircleAndDetail key={`service-circle-${i}`}>
                            <SingleCircleLocationCard>
                              <CircleGraph
                                key={i}
                                value={item.value}
                                title={item.name}
                              />
                            </SingleCircleLocationCard>
                            <SingleCircleDetail>
                              {item.name}
                              <br />
                              {item.detail}
                            </SingleCircleDetail>
                          </CircleAndDetail>
                        ))}
                      </CirclesGraphContainer>
                    </LocationDetail>
                  ))}
                </LocationDetailContainer>
              </Swipeable>
            )}
          </Map>
        </Main>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    zoomed: state.serviceCenters.isZoomed,
    serviceCenterLocations: state.serviceCenters.serviceCenterLocations,
    cardNo: state.serviceCenters.cardNo,
    activeLocation: state.serviceCenters.activeLocation,
    view: state.serviceCenters.view,
    isSettingOpen: state.serviceCenters.isSettingOpen,
    isLoading: state.serviceCenters.isLoading,
    counts: state.serviceCenters.counts,
    totalCount: state.serviceCenters.totalCount,

    data: state.services.data,
    filteredData: state.services.filteredData,
    isFiltered: state.services.isFiltered,

    scroll: state.app.scroll,

    theme: state.themes.theme
  };
};

const mapDispatchToProps = {
  handleLocationClick,
  handleLocationSwipe,
  filterService,
  changeMapView,
  closeZoom,
  toggleScroll,
  settingsClose: settingsToggle,
  resetState,
  getLocations,
  toggleLoading
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceCenters);
